// Import types
import type { SectionContentElement } from 'types/api/sections';

// Import styles
import { TitleContainer, TitleLink, TitleText, Image, InfoContent, Description, ButtonsWrapper } from './styles';

// Import components
import { MovieTrailer, ProductMetadata } from 'components/elements';
import { DetailButton } from 'components/views/vod/components/buttons/DetailsButton';
import { FavouriteButton } from 'components/views/vod/components/buttons/FavouriteButton';

// Import logic
import useElementInfo from './useElementInfo';

// Import utilities
import { useAuth } from 'components/utilities';

type Props = {
	product: SectionContentElement;
};

export function Info({ product }: Props) {
	const { uuid, title, subtype, hide_title, short_desc, context, type } = product;

	const { titleImage, handleGTMEvent, to, videoId } = useElementInfo(product);

	const { isAuth } = useAuth();

	return (
		<>
			<TitleContainer>
				{
					// Render title image. If image is missing, render title text if it's not deactivated.
					//Otherwise don't render anything
					titleImage ? (
						<>
							<Image src={titleImage} loading="lazy" alt={title} />
							<TitleLink to={to} aria-label={title} />
						</>
					) : (
						!hide_title && (
							<>
								<TitleText>{title}</TitleText>
								<TitleLink to={to} />
							</>
						)
					)
				}
			</TitleContainer>
			<InfoContent>
				{type === 'vod' && <ProductMetadata metadataLists={context?.extendedInfo?.metadata_lists} />}
				<Description>{short_desc}</Description>
				<ButtonsWrapper>
					<DetailButton title={title} uuid={uuid} subtype={subtype} />
					{videoId && <MovieTrailer uuid={uuid} GTMEvent={handleGTMEvent} videoId={videoId} />}
					{isAuth && <FavouriteButton uuid={uuid} GTMEvent={handleGTMEvent} />}
				</ButtonsWrapper>
			</InfoContent>
		</>
	);
}
